import { render, staticRenderFns } from "./MenuEventPermissions.vue?vue&type=template&id=1aa66f64"
import script from "./MenuEventPermissions.vue?vue&type=script&lang=js"
export * from "./MenuEventPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports